import React from 'react';
import { get } from 'lodash';

const ConfirmationEnroller = ({agentInfo}) => {
    return (
        <div className="row">
        <div className="col-md-5">
            <ul>
                <li>
                    Full Name:{' '}
                    <strong>
                        {get(agentInfo, 'userName')}
                    </strong>
                </li>
                <li>
                    Phone Number:{' '}
                    <strong>
                        {get(agentInfo, 'agentContactInfo.contactPhone')}
                    </strong>
                </li>
            </ul>
        </div>
        <div className="col-md-5">
            <ul>
                <li>
                    Address:{' '}
                    <strong>
                        {get(agentInfo, 'agentContactInfo.addressLine1')}
                    </strong>
                </li>
                <li>
                    City:{' '}
                    <strong>
                        {get(agentInfo, 'agentContactInfo.city')}
                    </strong>
                </li>
                <li>
                    State:{' '}
                    <strong>
                        {agentInfo?.agentContactInfo?.state}
                    </strong>
                </li>
            </ul>
        </div>
    </div>
    )
}

export default ConfirmationEnroller;